import { NavigationGuardNext, Route } from 'vue-router'

import { isLogin, toLogin } from '@utils/index'
import GrowthSouvenir from '../index.vue'
import Common from '../../common.vue'
// import Common from '../common.vue'
export default {
  path: '/',
  component: Common,
  children: [
    {
      name: 'growthSouvenir',
      path: 'growthSouvenir',
      component: () => import('../index.vue'),
    },
  //   {
  //     name: 'scenicTourism',
  //     path: 'scenicTourism',
  //     component: () => import('../../scenicTourism/index.vue'),
  // }
  ]
}
